import { Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import RootLayout from '../layout';

import * as S from './style';

export default function UnderMaintenance() {
  const { t } = useTranslation();

  return (
    <RootLayout>
      <S.UnderMaintenance>
        <Image name="underMaintenance" />
        <Typography variant="h1">{t('underMaintenanceText')}</Typography>
        <Typography variant="body1" fontWeight="700">
          {t('thankYouForYourPatience')}
        </Typography>
      </S.UnderMaintenance>
    </RootLayout>
  );
}
